import { ChangeEvent, useCallback, useState } from 'react';
import { SearchBarProps } from './SearchBar';

export const useHandleSearch = (onSearch: SearchBarProps['onSearch'], initialValue = '') => {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleSearch = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { value } = event.target;
      const currentTarget = event.currentTarget;

      setSearchTerm(value);
      setAnchorEl(currentTarget);

      if ((value.length === 0 || value.length > 2) && onSearch) {
        onSearch(value);
      }
    },
    [onSearch],
  );

  return { searchTerm, anchorEl, setAnchorEl, handleSearch };
};
